import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { lighten, saturate } from 'polished';
import React from 'react';

import config from '../../configs/websiteConfig';
import { Translate } from '../../locales/i18n';
import { colors } from '../../styles/colors';

export const SubscribeForm: React.FC = () => {
  return (
    <form
      noValidate
      css={SubscribeFormStyles}
      action={config.mailchimp.action}
      method="post"
      id="mc-embedded-subscribe-form"
      name="mc-embedded-subscribe-form"
      className="subscribe-form"
      target="_blank"
    >
      {/* This is required for the form to work correctly  */}
      <FormGroup className="form-group">
        <SubscribeEmail
          className="subscribe-email"
          type="email"
          name={config.mailchimp.emailFieldName}
          id={config.mailchimp.emailFieldName}
          placeholder={Translate.subscribe.placeholder}
        />
      </FormGroup>
      <input type="hidden" name="u" value={config.mailchimp.hiddenU} />
      <input type="hidden" name="id" value={config.mailchimp.hiddenId} />
      <SubscribeFormButton type="submit">
        <span>{Translate.subscribe.action}</span>
      </SubscribeFormButton>
    </form>
  );
};

const SubscribeFormStyles = css`
  display: flex;
  /* flex-direction: column; */
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  max-width: 460px;

  @media (max-width: 500px) {
    flex-direction: column;

    .form-group {
      flex-direction: column;
      width: 100%;
    }
  }
`;

const SubscribeEmail = styled.input`
  display: block;
  padding: 10px;
  width: 100%;
  /* border: color(var(--lightgrey) l(+7%)) 1px solid; */
  border: ${lighten('0.07', colors.lightgrey)} 1px solid;
  /* color: var(--midgrey); */
  color: ${colors.midgrey};
  font-size: 1.8rem;
  line-height: 1em;
  font-weight: normal;
  user-select: text;
  border-radius: 5px;
  transition: border-color 0.15s linear;

  -webkit-appearance: none;

  :focus {
    outline: 0;
    /* border-color: color(var(--lightgrey) l(-2%)); */
    border-color: ${lighten('-0.02', colors.lightgrey)};
  }

  @media (prefers-color-scheme: dark) {
    /* border-color: color(var(--darkmode) l(+6%)); */
    border-color: ${lighten('0.06', colors.darkmode)};
    color: rgba(255, 255, 255, 0.9);
    /* background: color(var(--darkmode) l(+3%)); */
    background: ${lighten('0.03', colors.darkmode)};

    :focus {
      /* border-color: color(var(--darkmode) l(+25%)); */
      border-color: ${lighten('0.25', colors.darkmode)};
    }
  }
`;

const SubscribeFormButton = styled.button`
  position: relative;
  display: inline-block;
  margin: 0 0 0 10px;
  padding: 0 20px;
  height: 43px;
  outline: none;
  color: #fff;
  font-size: 1.5rem;
  line-height: 39px;
  font-weight: 400;
  text-align: center;
  /* background: linear-gradient(
    color(var(--primary) whiteness(+7%)),
    color(var(--primary) lightness(-7%) saturation(-10%)) 60%,
    color(var(--primary) lightness(-7%) saturation(-10%)) 90%,
    color(var(--primary) lightness(-4%) saturation(-10%))
  ); */
  background: linear-gradient(
    ${lighten('0.07', colors.primary)},
    ${saturate('-0.1', lighten('-0.07', colors.primary))} 60%,
    ${saturate('-0.1', lighten('-0.07', colors.primary))} 90%,
    ${saturate('-0.1', lighten('-0.04', colors.primary))}
  );
  border-radius: 5px;

  -webkit-font-smoothing: subpixel-antialiased;

  :active,
  :focus {
    /* background: color(var(--primary) lightness(-9%) saturation(-10%)); */
    background: ${saturate('-0.1', lighten('-0.09', colors.primary))};
  }
  @media (max-width: 500px) {
    margin: 10px 0 0 0;
    width: 100%;
  }

  @media (prefers-color-scheme: dark) {
    opacity: 0.9;
  }
`;

const FormGroup = styled.div`
  @media (max-width: 500px) {
    width: 100%;
  }
`;
